import list from "./list";
import detail from "../users/detail";

export default {
    list: list,
    show: detail,
    name: "agency_customers",
    key: "p_agency_customers",
};
